import { TextareaControl as WPTextareaControl } from '@wordpress/components';

const TextareaControl = ({ field, value, ...rest }) => (
    <WPTextareaControl
        label={field.label}
        value={value}
        {...rest}
    />
);

export default TextareaControl;